import { fetchJSON } from '@/utils/http'
import { API_ROUTE } from '../backend/config'
import { TOSDocument } from './types'

export const getCurrentTOS = async (): Promise<TOSDocument> => {
  return await fetchJSON(`${API_ROUTE}/config/tos/current`)
}

export const acceptTOS = async (): Promise<void> => {
  return await fetchJSON(`${API_ROUTE}/users/tos-accept`, {
    method: 'POST',
    body: JSON.stringify({
      userAgent: navigator.userAgent,
    }),
  })
}
